var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplorerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 12,
    fill: "#58D9C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.159 39.6684L26.3219 44.2211C24.6566 44.8363 23.1637 43.2695 23.7789 41.6781L28.3316 29.841C28.5941 29.1438 29.1438 28.5941 29.841 28.3316L41.6781 23.7789C43.2695 23.1637 44.8363 24.6566 44.2211 26.3219L39.6684 38.159C39.4059 38.8563 38.8563 39.4059 38.159 39.6684ZM33.9262 31.375C32.548 31.375 31.3012 32.548 31.3012 34C31.3012 35.452 32.548 36.625 33.9262 36.625C35.452 36.625 36.625 35.452 36.625 34C36.625 32.548 35.452 31.375 33.9262 31.375ZM55 34C55 45.5992 45.5992 55 34 55C22.4008 55 13 45.5992 13 34C13 22.4008 22.4008 13 34 13C45.5992 13 55 22.4008 55 34ZM34 16.9375C24.5746 16.9375 16.9375 24.5746 16.9375 34C16.9375 43.4254 24.5746 51.0625 34 51.0625C43.4254 51.0625 51.0625 43.4254 51.0625 34C51.0625 24.5746 43.4254 16.9375 34 16.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorerIcon);
export default __webpack_public_path__ + "static/media/explorer-icon.7fa87255697ed7647b265fb8ceff699d.svg";
export { ForwardRef as ReactComponent };